import { render, staticRenderFns } from "./RunnitMarkColorLogo.vue?vue&type=template&id=5f58e66a&scoped=true"
import script from "./RunnitMarkColorLogo.vue?vue&type=script&lang=ts"
export * from "./RunnitMarkColorLogo.vue?vue&type=script&lang=ts"
import style0 from "./RunnitMarkColorLogo.vue?vue&type=style&index=0&id=5f58e66a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f58e66a",
  null
  
)

export default component.exports